import React from 'react';
import { Form } from 'fw/forms';
import { Button, Glyphicon } from 'react-bootstrap'

class SetupSearch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            form: Object.assign(this.initialForm(props), this.props.filters)
        }
    }

    initialForm() { return {}; }
    ready() { return null; }

    search = () => {
        const me = this;

        this.props.onSearch(this.state.form, function () {
            me.ready();
        });
    }

    reset = () => {
        const me = this;

        this.props.onReset(this.state.form, function () {
            me.ready();
        });
    }

    // Handlers
    handleSubmit = (e) => {
        e.preventDefault();
        this.search();
    }

    handleReset = (e) => {
        e.preventDefault();

        // Reset State
        this.setState({
            form: this.initialForm()
        }, function () {
            this.reset();
        });
    }

    handleChange = (form, callback) => {
        this.setState({ form }, callback);
    }

    handleOpenColSettings = () => {
        this.props.OnOpenColSettings();
    }

    // React
    componentDidMount() {
        if (this.props.triggerInitialSearch)
            this.search();
    }

    getButtonMargin = () => {
        return -35;
    }

    render() {
        var marginTop = this.getButtonMargin();
        return (
            <Form
                onSubmit={this.handleSubmit}
                onChange={this.handleChange}
                onReset={this.handleReset}
                values={this.state.form}>
                {this.renderForm()}
                <div className="pull-right" style={{ marginTop: marginTop }}>
                    <Button id="btnSearch" type="submit" bsStyle="primary" style={{ marginRight: 5, width: 70 }}>Search</Button>
                    <Button id="btnReset" type="reset" bsStyle="default" style={{ marginRight: 5, width: 70 }}>Reset</Button>
                    {
                        this.props.enableColumnSettings && this.props.setupKey &&
                        <Button id="btnSettings" type="button" onClick={this.handleOpenColSettings} bsStyle="default"><Glyphicon glyph="cog" /></Button>
                    }
                </div>
                <hr style={{ marginTop: "5px" }} />
            </Form>
        )
    }
}

export default SetupSearch;



// WEBPACK FOOTER //
// ./src/areas/shared/pages/setup/SetupSearch.js